import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { EVAL_VALUES } from 'components/utils'
import { RadioButtonGroup } from 'components/patterns'
import ReadOnlyParameterValue from 'components/feature/NavigatorPanes/editors/base/ReadOnlyParameterValue'
import { StyledEvaluationBadge } from './Evaluation.style'

const Evaluation = ({
  className,
  value,
  onChange,
  readonly,
  tooltip,
  noLabel,
}) => {
  // TODO: when conditions in the SubQueryCarryEditor can handle the TRUE/FALSE number input
  // remove the boolean check, because value will be then always 1 (for TRUE) or 0 (for FALSE)
  const { TRUE, FALSE } = EVAL_VALUES
  const evalFromOutput = [TRUE, FALSE].includes(value)

  const buttons = [
    { text: strings.true, value: evalFromOutput ? TRUE : true },
    { text: strings.false, value: evalFromOutput ? FALSE : false },
  ]

  // TODO: move to separate component?
  if (readonly) {
    const evalValue = evalFromOutput ? value === TRUE : value
    const valueLabel = evalValue ? strings.true : strings.false
    const renderValueLabel = (
      <>
        {valueLabel}
        <StyledEvaluationBadge value={evalValue} />
      </>
    )

    return (
      <ReadOnlyParameterValue
        className={className}
        label={strings.evaluation}
        value={renderValueLabel}
      />
    )
  }

  return (
    <RadioButtonGroup
      className={className}
      vertical
      label={noLabel ? '' : strings.evaluation}
      tooltip={tooltip}
      buttons={buttons}
      onChange={onChange}
      currentValue={value}
      radioGroupClassName="evaluation-radio-group"
    />
  )
}

Evaluation.defaultProps = {
  readonly: false,
}

Evaluation.propTypes = {
  className: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onChange: PropTypes.func,
  readonly: PropTypes.bool,
  noLabel: PropTypes.bool,
}

export default Evaluation
